

































import { Component, Vue, Ref } from 'vue-property-decorator'
import { evaluationRecordInfo, printResult } from '@/api/evaluation'
import Page1 from './_pages/Page1.vue'
import Page2 from './_pages/Page2.vue'
import Page3 from './_pages/Page3.vue'
import Page4 from './_pages/Page4.vue'
import Page5 from './_pages/Page5.vue'
import Page6 from './_pages/Page6.vue'
import Page7 from './_pages/Page7.vue'
import Page8 from './_pages/Page8.vue'
import Page9 from './_pages/Page9.vue'
import Page10 from './_pages/Page10.vue'
import Page11 from './_pages/Page11.vue'
import Page12 from './_pages/Page12.vue'
import Page13 from './_pages/Page13.vue'

import Page14 from './_pages/Page14.vue'
import Page15 from './_pages/Page15.vue'
import domain from '@/utils/domain'

@Component({
  components: {
    Page1,
    Page2,
    Page3,
    Page4,
    Page5,
    Page6,
    Page7,
    Page8,
    Page9,
    Page10,
    Page11,
    Page12,
    Page13,
    Page14,
    Page15
  }
})
export default class extends Vue {
  private energyZoneTypeMap: any = {
    '100': '综合能力',
    '101': '肌肉力量',
    '102': '平衡能力',
    '103': '身体柔韧',
    '104': '身体灵敏',
    '105': '心肺耐力'
  }
  private show: Boolean = false
  private info: any = ''
  private type: any = this.$route.query.type
  // 班级分析 用于区分是否分页
  private classType: any = this.$route.query.classType || '' // 101/102/103
  // 班级分析 能区
  private energyZoneType: any = this.$route.query.energyZoneType
  private page: any = this.$route.query.page
  private size: any = this.$route.query.size
  private physicalAnalysisPrintId: any = this.$route.query.physicalAnalysisPrintId
  private data: any = []
  created() {
    document.body.style.height = 'auto'
    document.body.style.minWidth = 'auto'
    document.body.style.background = '#FFFFFF'
    this.init()
  }
  private init() {
    let baseApi = ''
    baseApi = domain.BASE_API
    const protocolStr = document.location.protocol
    if (protocolStr === 'https:') {
      baseApi = baseApi.replace('http:', 'https:')
    }
    var url = baseApi + `/api-evaluation/admin/physicalAnalysisPrint/${this.type}`
    var xhr = new XMLHttpRequest()
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        const res = JSON.parse(xhr.responseText)
        this.show = true
        this.data = res.data
      }
    }
    xhr.open('POST', url, false)
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    const data = {
      physicalAnalysisPrintId: this.physicalAnalysisPrintId,
      energyZoneType: this.energyZoneType,
      page: this.page,
      size: this.size
    }
    let ret = ''
    for (const it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    ret = ret.substring(0, ret.length - 1)
    xhr.send(ret)
  }
  private reset() {
    (this.$refs.table as any).search()
  }
  updateTable() {
    (this.$refs.table as any).update()
  }
}
